import axios from 'axios';
import { baseUrl } from '@/config';
import { forEach, isEmpty } from 'lodash';

export default {
  /**
   * 서버 논리 그룹 트리를 조회한다.
   * @author Ju
   * @return {Object} [response 객체]
   */
  getServerLogicalTree() {
    return axios.get(`${baseUrl}/settings/common/operation/get-server-logical-tree.do`);
  },
  /**
   * 운영 포트 설정을 업데이트한다.
   * @author Song
   * @param  {Object} params
   */
  setOperationPort(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/set-operation-port.do`, params);
  },
  /**
   * 데이터 보유기간 목록 및 최대 기간에 대한 정보를 함께 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getResourceKeepingPeriodList() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-resource-keeping-period-list.do`);
  },
  /**
   * 데이터 보유기간을 수정한다.
   * @author Song
   * @return {Object} params
   */
  setResourceKeepingPeriodData(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/set-resource-keeping-period-data.do`, params);
  },
  /**
   * 모든 도메인 ip를 조회한다.
   * @author Song
   * @return {Object} params
   */
  getSettingDomainIpList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-net-ip-domain-name.do`, params);
  },
  /**
   * 입력한 도메인을 추가한다.
   * @author Song
   * @return {Object} params
   */
  addNetIpDomainName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/add-net-ip-domain-name.do`, params);
  },
  /**
   * 선택한 도메인들을 제거한다.
   * @author Song
   * @return {Object} params
   */
  delNetIpDomainName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/del-net-ip-domain-name.do`, params);
  },
  /**
   * 서비스 포트를 조회한다.
   * @author Song
   * @return {Object} params
   */
  getNetPortSvcName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-net-port-svc-name.do`, params);
  },
  /**
   * 대상 서비스 포트를 삭제한다.
   * @author Song
   * @return {Object} params
   */
  delNetPortSvcName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/del-net-port-svc-name.do`, params);
  },
  /**
   * 입력한 서비스 포트를 추가한다.
   * @author Song
   * @return {Object} params
   */
  addNetPortSvcName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/add-net-port-svc-name.do`, params);
  },
  /**
   * 대상 도메인 데이터를 수정한다.
   * @author Song
   * @return {Object} params
   */
  setNetIpDomainName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/set-net-ip-domain-name.do`, params);
  },
  /**
   * 대상 서비스 포트 데이터를 수정한다.
   * @author Song
   * @return {Object} params
   */
  setNetPortSvcName(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/set-net-port-svc-name.do`, params);
  },
  /**
   * 이미지 그룹을 조회한다.
   * @author Song
   * @return {Object} params
   */
  getImageGroupList() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-customimage-type-list.do`);
  },
  /**
   * 해당 이미지 그룹의 리스트를 조회한다.
   * @author Song
   * @return {Object} params
   */
  getImageList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-imagetype-customimage-list.do`, params);
  },
  /**
   * 해당 이미지의 정보를 수정한다. (그룹이 아닌 customimageId들의)
   * @author Song
   * @return {Object} params
   */
  setCustomImage(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/set-customimage.do`, params);
  },
  /**
   * 해당 이미지의 그룹 정보를 수정한다.
   * @author Song
   * @return {Object} params
   */
  setCustomImageGroup(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/edit-customimage-type.do`, params);
  },
  /**
   * [getUrgencyList 긴급도 설정 목록을 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getUrgencyList() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-urgency-list.do`);
  },
  /**
   * [updateItsmUrgency 긴급도 항목을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateItsmUrgency(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-itsm-urgency.do`, params);
  },
  /**
   * [updateItsmUrgency 긴급도 항목을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteItsmUrgency(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-itsm-urgency.do`, params);
  },
  /**
   * [updateItsmUrgency 긴급도 항목을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertItsmUrgency(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/insert-itsm-urgency.do`, params);
  },
  /**
   * [getImpactList 영향도 설정 목록을 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getImpactList() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-impact-list.do`);
  },
  /**
   * [updateItsmImpact 영향도 항목을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateItsmImpact(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-itsm-impact.do`, params);
  },
  /**
   * [updateItsmImpact 영향도 항목을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertItsmImpact(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/insert-itsm-impact.do`, params);
  },
  /**
   * [deleteItsmImpact 영향도 항목을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteItsmImpact(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-itsm-impact.do`, params);
  },
  /**
   * 새폴더(신규그룹)을 추가한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object} params
   */
  addCustomimageType(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/add-customimage-type.do`, params);
  },
  /**
   * 이미지를 추가한다.
   * @author Song
   * @return {Object} params
   */
  addCustomImage(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/add-customimage.do`, params);
  },
  setBasicInfo(params) {
    return axios.get(`${baseUrl}/settings/operation-setting/set-basic-info.do`, { params });
  },
  /**
   * 이미지를 삭제한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object} params
   */
  deleteCustomImage(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-customimage.do`, params);
  },
  /**
   * 이미지 그룹을 삭제한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object} params
   */
  deleteCustomimageType(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-customimage-type.do`, params);
  },
  /**
   * 이미지를 내려받는다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object} params
   */
  downloadCustomImage(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/operation-setting/download-customimage.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 알람 설정을 업데이트한다.(저장)
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object} params
   */
  updateAlarmConfigData(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-alarm-config-data.do`, params);
  },
  /**
   * 단문메시지 DB Table Field : default
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  getDefaultTableField() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-default-table-field.do`);
  },
  /**
   * 단문메시지 DB Table Value : default
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  getDefaultTableValue() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-default-table-value.do`);
  },
  /**
   * 알람 테스트를 실행한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}0
   */
  executeAlarmTest(params) {
    return axios.get(`${baseUrl}/settings/operation-setting/alarm-test.do?param=${params.param}`);
  },
  /**
   * 알람 전송 템플릿 목록 및 total 갯수를 조회한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  getAlarmTemplateList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-alarm-template-list.do`, params);
  },
  /**
   * 알람 전송 템플릿을 추가한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  addAlarmTemplate(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/add-alarm-template.do`, params);
  },
  /**
   * 알람 전송 템플릿을 수정한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  updateAlarmTemplate(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-alarm-template.do`, params);
  },
  /**
   * 알람 전송 템플릿을 삭제한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  deleteAlarmTemplate(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-alarm-template.do`, params);
  },
  /**
   * 알람 전송 결과를 조회한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  getManagerAlarmSendResultList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-manager-alarm-send-result-list.do`, params);
  },
  /**
   * 메시지 포멧 리스트를 조회한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  getMessageFormatList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-message-format-list.do`, params);
  },
  /**
   * 메시지 포멧 리스트를 수정한다.
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  updateMessageFormat(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-message-format.do`, params);
  },
  /**
   * 긴급도와 영향도 조회 (basicinfo_subid 기준으로 정렬이 필요하여 생성)
   * @author Song
   * @param  {[type]} params [description]
   * @return {Object}
   */
  getUrgencyAndImpactBasicData() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-urgency-impact-basic-data.do`);
  },
  /**
   * 영향도 존재 여부를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  existImpact(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/exist-impact.do`, params);
  },
  /**
   * 긴급도 존재 여부를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  existUrgency(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/exist-urgency.do`, params);
  },
  /**
   * 도메인 존재여부를 조회한다.
   * @param  {[type]}  params [description]
   * @return {Boolean}        [description]
   * @author jda
   */
  isExistDomain(params) {
    return axios.get(`${baseUrl}/settings/operation-setting/is-exist-domain.do`, { params });
  },
  /**
   * 서비스 포트 존재 여부를 조회한다.
   * @param  {[type]}  params [description]
   * @return {Boolean}        [description]
   * @author jda
   */
  isExistPort(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/is-exist-port.do`, params);
  },
  /**
   * DB종류 별 단문메세지 전송 DB 드라이버명과 url 정보를 반환한다.
   * @author Ju
   * @param  {[type]} dbType [description]
   * @return {[type]}        [description]
   */
  getDatabaseInfo(dbType) {
    return axios.get(`${baseUrl}/settings/operation-setting/get-database-info.do`, { params: { dbType } });
  },
  /**
   * 운영설정 > 타제품연동 > 관리대상 > 통합관리 관리대상 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getEmsObjList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-ems-obj-list.do`, params);
  },
  /**
   * 운영설정 > 타제품연동 > 관리대상 > 최근 3일이내 추가된 통합관리 관리대상 갯수 조회
   * @author jeee12
   * @return {[type]}        [description]
   */
  getRecentRegisteredEmsObjCount() {
    return axios.get(`${baseUrl}/settings/operation-setting/get-recent-registered-ems-obj-count.do`);
  },
  /**
   * 운영설정 > 타제품연동 > 관리대상 > 최근 3일이내 추가된 통합관리 관리대상 갯수 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateEmsObjList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-ems-obj-list.do`, params);
  },
  /**
   * 운영설정 > 타제품연동 > 관리대상 > 통합관리 관리대상 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteEmsObjList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-ems-obj-list.do`, params);
  },
  /**
   * 운영설정 > 이벤트/알람 > 장애 연관장비 > Root Cause 연관 관계 트리를 가져온다.
   * @author Song
   * @return {[type]}        [description]
   */
  getRootCauseTree(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-root-cause-tree.do`, params);
  },
  /**
   * 운영설정 > 이벤트/알람 > 장애 연관장비 > Root Cause 연관 관계 트리 - 변경 사항 업데이트
   * @author Song
   * @return {[type]}        [description]
   */
  updateRootCauseTreeList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/update-root-cause-tree-list.do`, params);
  },
  /**
   * 운영설정 > 이벤트/알람 > 장애 연관장비 > Root Cause 연관 관계 트리 - 트리 삭제
   * @author Song
   * @return {[type]}        [description]
   */
  deleteRootCauseTreeList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/delete-root-cause-tree-list.do`, params);
  },
  /**
   * 설정 > 운영 > 헬스체크 > 서버 - 에이전트 정보를 조회한다. (DB 쿼리 데이터)
   * @author Song
   * @return {[type]}        [description]
   */
  getServerAgentInfoList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-server-agent-info-list.do`, params);
  },
  /**
   * 설정 > 운영 > 헬스체크 > 서버 - 에이전트 정보를 조회한다.  (onDemand 포함)
   * @author Song
   * @return {[type]}        [description]
   */
  getServerAgentHealthList(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/get-server-agent-health-list.do`, params);
  },
  /**
   * 설정 > 운영 > 헬스체크 > 서버 - 에이전트 기동/중지 실시한다.
   * @author Song
   * @return {[type]}        [description]
   */
  executeServerAgent(params) {
    return axios.post(`${baseUrl}/settings/operation-setting/execute-server-agent.do`, params);
  },
  /**
   * 설정 > 운영 > 헬스체크 > 서버 - 에이전트 목록 엑셀 출력
   * @author Song
   * @return {[type]}        [description]
   */
  exportServerAgentHealthList() {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/operation-setting/export-server-agent-health-list.do`;
    form.method = 'get';
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/operation-settings.js